import React from "react";
import "../styles/Slide.scss";

const Slide = () => {
  return (
    <div className="slide">
      <h1>
        Renting just got easier and enjoyable <br /> Get well detailed Rentals
        from anywhere in Nigeria
      </h1>
    </div>
  );
};

export default Slide;
